export default __webpack_public_path__ + "static/media/signature.0c17e149.png";